import { Component, OnInit } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";
import { IonicModule } from "@ionic/angular";

@Component({
    selector: "app-windows-game-play-popup",
    templateUrl: "./windows-game-play-popup.component.html",
    styleUrls: ["./windows-game-play-popup.component.scss"],
    standalone: true,
    imports: [IonicModule],
})
export class WindowsGamePlayPopupComponent implements OnInit {
  constructor(public dialogRef: MatDialogRef<WindowsGamePlayPopupComponent>) {}

  ngOnInit() {}
  close() {
    this.dialogRef.close();
  }
}
